import { render, staticRenderFns } from "./CadastroAcompanhamentoPublicacoes.vue?vue&type=template&id=00c14d87&scoped=true"
import script from "./CadastroAcompanhamentoPublicacoes.vue?vue&type=script&lang=js"
export * from "./CadastroAcompanhamentoPublicacoes.vue?vue&type=script&lang=js"
import style0 from "./CadastroAcompanhamentoPublicacoes.vue?vue&type=style&index=0&id=00c14d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c14d87",
  null
  
)

export default component.exports